/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FeedbackResponse = {
    id?: string;
    text?: string;
    isPublic?: boolean;
    date?: string;
    status?: FeedbackResponse.status;
    category?: FeedbackResponse.category;
    authorId?: string;
    author?: string;
};
export namespace FeedbackResponse {
    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        RESOLVED = 'RESOLVED',
        ARCHIVED = 'ARCHIVED',
    }
    export enum category {
        GENERAL = 'GENERAL',
        BUG = 'BUG',
        FEATURE = 'FEATURE',
        IMPROVEMENT = 'IMPROVEMENT',
        OTHER = 'OTHER',
    }
}

